import { render, staticRenderFns } from "./ShenPiNewYanfaBx.vue?vue&type=template&id=eff0aaa8&scoped=true&"
import script from "./ShenPiNewYanfaBx.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewYanfaBx.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewYanfaBx.vue?vue&type=style&index=0&id=eff0aaa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0aaa8",
  null
  
)

export default component.exports